<template>
    <v-row class="mt-4">
        <v-col class="pt-0">
            <v-card class="">
                <v-card-title class="pb-1">
                    بيانات الموظف
                </v-card-title>
                <v-card-text>
                    <p>
                        تقييم الأداء عن فترة :
                    </p>
                    <v-row align="center">
                        <v-col cols="6">
                            <v-text-field
                                dense
                                outlined
                                hide-details
                                label="من تاريخ"
                            />
                        </v-col>

                        <v-col cols="6">
                            <v-text-field
                                dense
                                outlined
                                hide-details
                                label="إلى تاريخ"
                            />
                        </v-col>

                        <v-col cols="6">
                            <v-text-field
                                dense
                                outlined
                                hide-details
                                label="الوظيفة"
                            />
                        </v-col>

                        <v-col cols="6">
                            <v-autocomplete
                                :items="[]"
                                dense
                                outlined
                                hide-details
                                label="القسم"
                            />
                        </v-col>
                        <v-col cols="12">
                            اسم المدير: أحمد 
                        </v-col>
                    </v-row>                 
                </v-card-text>
            </v-card>
        </v-col>

        <v-col cols="6" class="py-0">
            <!-- <v-card width="100%" class="ma-2 scroll-style">
                <v-card-text> -->
                    <!-- <v-row  v-for="(item, index) in items" :key="index">
                        <v-col>
                            <div >
                                <h3 v-if="index === 0"> {{ item }} </h3>
                                <span v-else> {{ item }} </span>
                            </div>
                        </v-col>
    
                        <v-col>
                            <h3 v-if="index === 0"> درجة التقييم </h3>
                            <v-text-field
                                v-if="index !== 0"
                                label="العلامة"
                                dense
                                outlined
                                hide-details=""
                            />
                        </v-col>
                    </v-row> -->
                    <bee-handy-table
						:headers="headers"
						:items="items"
						dense
						zebra
						height="auto"
						:items-per-page="-1"
						fixed-header
						hide-default-footer
					>
						<template v-slot:item.mark="{}">
							<v-text-field
								dense
								hide-details
							/>
						</template>
					</bee-handy-table>
                <!-- </v-card-text>
            </v-card> -->
        </v-col>

    </v-row>
</template>

<script>
export default {
    data() {
        return {
            headers: [
                {
                    text: 'عناصر التقييم',
                    name: 'name',
                    value: 'name'
                },
                {
                    text: 'درجة التقييم',
                    name: 'mark',
                    value: 'mark'
                }
            ],
            items: [
                {
                    name: 'عناصر التقييم',
                    mark: ''
                },
                {
                    name: 'الإنتاجية',
                    mark: ''
                },
                {
                    name: 'الالتزام بأوقات و ساعات العمل',
                    mark: ''
                },
                {
                    name: 'المعرفة بالمتطلبات الوظيفية',
                    mark: ''
                },
                {
                    name:  'التعبير الكتابي',
                    mark: ''
                },
                {
                    name: 'التعبير الشفهي',
                    mark: ''
                },
                {
                    name: 'الإعداد و المتابعة',
                    mark: ''
                },
                {
                    name: 'التواصل مع المسؤول المباشر',
                    mark: ''
                },
                {
                    name: 'حل المسائل المعقدة',
                    mark: ''
                },
                {
                    name: 'اتخاذ القرارات',
                    mark: ''
                },
                {
                    name: 'العلاقات مع الموظفين',
                    mark: ''
                },
                {
                    name: 'العلاقة مع مشرفين اخرين',
                    mark: ''
                },
                {
                    name: 'السلوك تجاه العمل',
                    mark: ''
                },
                {
                    name: 'الرغبة بالتعلم و التطوير',
                    mark: ''
                },
                {
                    name: 'القدرة على التكييف مع بيئة العمل',
                    mark: ''
                },
                {
                    name: 'القدرة على الإضافة للوظيفة',
                    mark: ''
                },
                {
                    name: 'النتيجة',
                    mark: ''
                }
            ],
        }
    }
}
</script>

<style scoped>
.scroll-style {
    float:left;
    width: 100%;
    overflow-y: auto;
    height: 900px;
}
</style>